import request from '@/utils/request'

const tagApi = {
  tag_list: '/tag/',
  tag_create: '/tag/',
  tag_update: '/tag/',
  tag_delete: '/tag/'
}

/**
 * 列表
 */
export function tag_list (parameter) {
  return request({
    url: tagApi.tag_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function tag_create (parameter) {
  return request({
    url: tagApi.tag_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function tag_update (parameter, tag_id) {
  return request({
    url: tagApi.tag_update + tag_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function tag_delete (tag_id) {
  return request({
    url: tagApi.tag_delete + tag_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
